/* global $ */

const platform_features = [
  {
    icon: "bi-people",
    title: "Multi-Stakeholder Management",
    description:
      "Manage clients, consultants, and internal teams with role-based access control. Assign responsibilities per BEE element.",
  },
  {
    icon: "bi-bar-chart-line",
    title: "Real-Time Element Dashboards",
    description:
      "Track Ownership, Management Control, Skills Development, ESD, SED, and YES programmes with live metrics and trends.",
  },
  {
    icon: "bi-file-earmark-check",
    title: "Document Verification Workflow",
    description:
      "Upload, review, and approve artefacts with audit trail. Prepare comprehensive verification packs for SANAS audits.",
  },
  {
    icon: "bi-bell",
    title: "Smart Alert System",
    description:
      "Never miss a deadline. Get notified about document expiries, EE meetings, WSP submissions, and verification milestones.",
  },
  {
    icon: "bi-shield-check",
    title: "Compliance Checklists",
    description:
      "Pre-configured checklists per element ensure you have all required documentation for verification.",
  },
  {
    icon: "bi-briefcase",
    title: "Year-by-Year Audit Folders",
    description:
      "Organize verification documents by financial year. Lock folders, export audit packs, and maintain immutable records.",
  },
];

/* ===============================
   RENDER PLATFORM FEATURES
   =============================== */

$(document).ready(function () {
  const $grid = $("#platform_features_grid");
  const template = document.getElementById("platform_feature_template");

  // Silently return if template or grid doesn't exist (not on landing page)
  if (!template || !$grid.length) {
    return;
  }

  $.each(platform_features, function (_, feature) {
    const feature_node = template.content.cloneNode(true);

    const $feature_node = $(feature_node);
    const $feature_icon = $feature_node.find(".feature_icon");
    const $feature_title = $feature_node.find(".feature_title");
    const $feature_description = $feature_node.find(".feature_description");

    $feature_icon.addClass(feature.icon);
    $feature_title.text(feature.title);
    $feature_description.text(feature.description);

    $grid.append($feature_node);
  });
});
